import { Component, OnInit } from '@angular/core';
import { InfraccionService } from '../../../../../shared/services/infracciones.service';
import {
  
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke
  } from "ng-apexcharts";

  export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  };

  export type ChartOptions2 = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    tooltip: ApexTooltip;
    dataLabels: ApexDataLabels;
    };
    export type ChartOptions3 = {
      series: ApexAxisChartSeries;
      chart: ApexChart;
      xaxis: ApexXAxis;
      stroke: ApexStroke;
      tooltip: ApexTooltip;
      dataLabels: ApexDataLabels;
      };

@Component({
  selector: 'app-graficos-multas',
  templateUrl: './graficos.component.html',
  styleUrls: ['./graficos.component.scss']
})
export class GraficosMultasComponent implements OnInit  {
  public chartOptions: any;
  public chartOptions2: any;
  public chartOptions3: any;

  //pendiente de pago
  porcentajePendiente: number = 0;
  cantidadPendiente: number = 10;
  
  //Acuerdo de pago
  porcentajeAcuerdo: number = 0;
  cantidadAcuerdo: number = 0;  

  //Pagado
  porcentajePagado: number=0;
  cantidadPagado: number=0;
  
  conteoPorEstado: any[] = [];

  //total
  multaTotales: number = 0;

  constructor(private infraccionesService: InfraccionService) {}

  ngOnInit() {

    this.infraccionesService.conteoPorEstado$.subscribe((conteoPorEstado) => {
     // console.log(conteoPorEstado);
      if (conteoPorEstado) {
       // console.log(conteoPorEstado);
        this.conteoPorEstado =conteoPorEstado;
        
        // Asignar las cantidades según el estado
        this.cantidadPendiente = this.obtenerCantidadPorEstado('PENDIENTE DE PAGO');
        console.log("PENDIENTE:"+ this.cantidadPendiente);

        this.cantidadAcuerdo = this.obtenerCantidadPorEstado('ACUERDO DE PAGO');
        console.log("ACUERDO:"+ this.cantidadAcuerdo);

        this.cantidadPagado = this.obtenerCantidadPorEstado('PAGADO');
       //  console.log(this.cantidaVigente);


        this.multaTotales = this.cantidadPendiente + this.cantidadAcuerdo + this.cantidadPagado;
       
      this.porcentajePendiente = Math.round((this.cantidadPendiente / this.multaTotales) * 100 * 100) / 100;
      this.porcentajeAcuerdo = Math.round((this.cantidadAcuerdo / this.multaTotales) * 100 * 100) / 100;
      this.porcentajePagado = Math.round((this.cantidadPagado / this.multaTotales) * 100 * 100) / 100;



      this.cargarGrafico();
      }
    });
    
  
    
   
   
  }

  // Función para obtener la cantidad de un estado específico
  obtenerCantidadPorEstado(estado: string): number {
    const estadoEncontrado = this.conteoPorEstado.find((e) => e.estado === estado);
    return estadoEncontrado ? estadoEncontrado.cantidad : 0;
  }
  
  
  cargarGrafico() {

    this.chartOptions = {
      series: [this.porcentajePendiente],
      chart: {
        height: 130,
        type: "radialBar",
        dropShadow: {
          enabled: true,
          top: 3,
          left: 0,
          blur: 10,
          color: "#FF3364",
          opacity: 0.35,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "55%",
          },
          track: {
            strokeWidth: "60%",
            opacity: 1,
            margin: 5,
          },
          dataLabels: {
            showOn: "always",
            value: {
              color: "var(--body-font-color)",
              fontSize: "14px",
              show: true,
              offsetY: -10,
            },
          },
        },
      },
      colors: ["#FF3364"],
      stroke: {
        lineCap: "round",
      },
      responsive: [
        {
          breakpoint: 1500,
          options: {
            chart: {
              height: 130,
            },
          },
        },
      ],
    }

  this.chartOptions2 = {
    series: [this.porcentajeAcuerdo],
    chart: {
      height: 130,
      type: "radialBar",
      dropShadow: {
        enabled: true,
        top: 3,
        left: 0,
        blur: 10,
        color: "#EEBA11",
        opacity: 0.35,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "55%",
        },
        track: {
          strokeWidth: "60%",
          opacity: 1,
          margin: 5,
        },
        dataLabels: {
          showOn: "always",
          value: {
            color: "var(--body-font-color)",
            fontSize: "14px",
            show: true,
            offsetY: -10,
          },
        },
      },
    },
    colors: ["#EEBA11"],
    stroke: {
      lineCap: "round",
    },
    responsive: [
      {
        breakpoint: 1500,
        options: {
          chart: {
            height: 130,
          },
        },
      },
    ],
  }
  
  this.chartOptions3 = {
    series: [this.porcentajePagado],
    chart: {
      height: 130,
      type: "radialBar",
      dropShadow: {
        enabled: true,
        top: 3,
        left: 0,
        blur: 10,
        color: "#1DE279",
        opacity: 0.35,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "55%",
        },
        track: {
          strokeWidth: "60%",
          opacity: 1,
          margin: 5,
        },
        dataLabels: {
          showOn: "always",
          value: {
            color: "var(--body-font-color)",
            fontSize: "14px",
            show: true,
            offsetY: -10,
          },
        },
      },
    },
    colors: ["#1DE279"],
    stroke: {
      lineCap: "round",
    },
    responsive: [
      {
        breakpoint: 1500,
        options: {
          chart: {
            height: 130,
          },
        },
      },
    ],
  }
}
  
  
  
}
